<template lang="pug">
v-autocomplete(
  dense,
  v-model="dataBank",
  :disabled="disabled",
  :readonly="readonly",
  :label="label",
  :rules="rules",
  :items="listData",
  :item-text="text",
  item-value="sknCode",
  @change="onSelect",
  :required="required"
)
</template>
<script>
export default {
  name: "FSelectBankExt",
  props: ["value", "disabled", "readonly", "label", "rules", "required"],
  data() {
    return {
      dataBank: {},
      listData: [],
    };
  },
  mounted() {
    this.doInit(this.value);
  },
  created() {
    this.doLoad();
  },
  watch: {
    value(val) {
      this.doInit(val);
    },
  },
  methods: {
    text: (item) => item.sknCode + " - " + item.initialName,
    doInit(values) {
      this.dataBank = values ? values : null;
    },
    doLoad() {
      this.$http.get("/api/parameter/bank-ext").then((success) => {
        this.listData = success.data;
        this.onSelect();
      });
    },
    onSelect() {
      this.$emit("input", this.dataBank);
      this.$emit("select", this.dataBank);
      this.$emit("bankExt", this.valueData());
    },
    valueData() {
      let result = null;
      this.listData.map((element) => {
        if (this.dataBank === element.sknCode) {
          result = element;
        }
      });
      return result;
    },
  },
};
</script>